package org.matthewo.schema.games

import org.matthewo.math.minus
import org.matthewo.math.plus
import org.matthewo.schema.RankingMetrics
import org.matthewo.schema.StandardMetrics
import org.matthewo.symbolprocessor.GameSchema
import org.matthewo.symbolprocessor.Metric
import org.matthewo.symbolprocessor.Period

@GameSchema(2023, "Center Stage", 2)
interface MetricsCenterStage<T : Number> : StandardMetrics<T>, RankingMetrics<T> {
    override val tbp1 get() = auto

    @Metric(Period.AUTO, "Purple")
    val apPurple: T

    @Metric(Period.AUTO, "Yellow")
    val apYellow: T

    @Metric(Period.AUTO, "Navigation")
    val apNavigation: T

    @Metric(Period.AUTO, "Backstage")
    val apBackstage: T

    @Metric(Period.AUTO, "Backdrop")
    val apBackdrop: T

    @Metric(Period.TELEOP, "Backstage")
    val tpBackstage: T

    @Metric(Period.TELEOP, "Backdrop")
    val tpBackdrop: T

    @Metric(Period.TELEOP, "Mosaic")
    val tpMosaic: T

    @Metric(Period.TELEOP, "Set")
    val tpSet: T

    @Metric(Period.ENDGAME, "Drone")
    val epDrone: T

    @Metric(Period.ENDGAME, "Hang")
    val epHang: T

    @Metric(Period.ENDGAME, "Park")
    val epPark: T
}

fun <T : Number> MutableMetricsCenterStage<T>.computeTotals() {
    auto = apPurple + apYellow + apNavigation + apBackstage + apBackdrop
    teleop = tpMosaic + tpSet + tpBackstage + tpBackdrop
    endgame = epDrone + epHang + epPark
    npTotal = auto + teleop + endgame
    total = npTotal - penalty
}
